import { Component, Input } from '@angular/core';
import { BaseComponent } from 'src/app/components/base-component';
import { Subscriber } from 'src/app/shared/models/signature.model';
import { Signer } from 'src/app/shared/models/signer';

@Component({
  selector: 'app-subscriber-list',
  templateUrl: './subscriber-list.component.html',
  styleUrls: ['./subscriber-list.component.scss']
})
export class SubscriberListComponent extends BaseComponent {

  @Input() signerList:Subscriber[] = [];

  constructor() {super();}
}
